import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@clerk/clerk-react";
import { createApiClient } from "../api/ApiClient";
import type { BillingInterval } from "./useProduct";

export interface CreateProductData {
  name: string;
  description: string;
  price: number;
  currency: string;
  billing_interval: BillingInterval;
  billing_interval_count: number;
  active: boolean;
  requires_delivery_address: boolean;
  /** Days of trial for new subscribers; null for none. */
  trial_days: number | null;
  /** One-off trial charge in major units; null for a free trial. */
  trial_price: number | null;
}

export function useCreateProduct() {
  const { getToken } = useAuth();
  const api = createApiClient(getToken);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateProductData) =>
      api.post<unknown>("/vendors/dashboard/products", data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["dashboard-products"] });
    },
  });
}
